import { render } from "./ModalPagoFactura.vue?vue&type=template&id=0fde56f4&scoped=true"
import script from "./ModalPagoFactura.vue?vue&type=script&lang=js"
export * from "./ModalPagoFactura.vue?vue&type=script&lang=js"

import "./ModalPagoFactura.vue?vue&type=style&index=0&id=0fde56f4&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fde56f4"]])

export default __exports__